import axios from "axios";
import store from "@/store";

export default {
    loginredirect() {
        store.commit("SET_SNACKBAR", {
            active: true,
            body: "مجوز شما باطل شده است، لطفا دوباره وارد شوید.",
            color: "red",
        });
        store.commit("SET_ISAUTHENTICATED", false);
    },
    //  getDeviceStatusRequest({ commit }, { self }) {
    //     self.$store.state.loadingDialog = true;
    //     axios
    //         .get(
    //             "http://Y9KR1FdtTtoWtAb3YxSB1L48BjZGsgYq@mqtt.goldwaretech.com:8888/api/v1/sessions/show", //Controller URL
    //             {
    //                 //Headers
    //                 headers: {
    //                    // Authorization: "Basic WTlLUjFGZHRUdG9XdEFiM1l4U0IxTDQ4QmpaR3NnWXE6WTlLUjFGZHRUdG9XdEFiM1l4U0IxTDQ4QmpaR3NnWXE=",
    //                 },
    //             }
    //         )
    //         .then((response) => {
    //             var data = response.data;
    //             commit("SET_DEVICESTATUS", data);
    //             self.$store.state.loadingDialog = false;
    //             self.requestParams.callBack(200);
    //         })
    //         .catch((error) => {
    //             if (error && error.response && error.response.status) {
    //                 store.state.loadingDialog = false;
    //                 store.commit("SET_SNACKBAR", {
    //                         active: true,
    //                         body: "برقراری ارتباط با سرور MQTT با مشکل مواجه شده است.",
    //                         color: "#ab0000",
    //                     });
    //                 return;

    //             }
    //             self.requestParams.callBack(-200);
    //             self.$store.state.loadingDialog = false;
    //         });
    // },
    getRequest({ commit }, { self }) {
        var requestParams = self.requestParams;
        self.$store.state.loadingDialog = true;
        axios
            .get(
                self.$store.state.settings.server + requestParams.controller, //Controller URL
                {
                    //Headers
                    headers: {
                        Authorization: "Bearer " + self.$store.state.userInfo.accessToken,
                    },
                }
            )
            .then((response) => {
                var data = response.data;
                console.log(response);
                commit(requestParams.commitFunction, data);
                self.$store.state.loadingDialog = false;
                self.requestParams.callBack(200);
            })
            .catch((error) => {
                if (error && error.response && error.response.status) {
                    if (error.response.status == 401) {

                        store.state.loadingDialog = false;
                        store.dispatch("loginredirect");
                        self.$router.push("login");

                    }
                    else if (error.response.status == 404) {

                        store.state.loadingDialog = false;
                        store.commit("SET_SNACKBAR", {
                            active: true,
                            body: "کنترلر مورد نظر یافت نشد، لطفا اتصال اینترنت خود را بررسی کنید.",
                            color: "#ab0000",
                        });

                    }
                    else {
                        store.commit("SET_SNACKBAR", {
                            active: true,
                            body: error.response.data.Msg,
                            color: "#ab0000",
                        });
                        self.$store.state.loadingDialog = false;
                    }

                }
                self.requestParams.callBack(-200);
                self.$store.state.loadingDialog = false;
            });
    },
    postRequest({ commit }, { self }) {
        var requestParams = self.requestParams;
        self.$store.state.loadingDialog = true;
        axios
            .post(
                self.$store.state.settings.server + requestParams.controller, //Controller URL
                requestParams.data, //POST Data
                {
                    //Headers
                    headers: {
                        Authorization: "Bearer " + self.$store.state.userInfo.accessToken,
                    },
                }
            )
            .then((response) => {
                var data = response.data;
                self.$store.state.loadingDialog = false;
                if (Number.isFinite(data)) {
                    self.requestParams.callBack(data);
                }
                commit(requestParams.commitFunction, data);
                self.requestParams.callBack(200);
            })
            .catch((error) => {
                if (error && error.response && error.response.status) {
                    if (error.response.status == 401) {
                        store.state.loadingDialog = false;
                        store.dispatch("loginredirect");
                        self.$router.push("login");
                        return;
                    }
                    else if (error.response.status == 400) {
                        store.state.loadingDialog = false;
                        store.commit("SET_SNACKBAR", {
                            active: true,
                            body: "لطفا ورودی های خود را بررسی کنید.",
                            color: "#ab0000",
                        });
                        return;
                    }
                    else {
                        store.state.loadingDialog = false;
                        store.commit("SET_SNACKBAR", {
                            active: true,
                            body: error.response.data.Msg,
                            color: "#ab0000",
                        });
                        return
                    }
                }
                self.requestParams.callBack(-200);
                self.$store.state.loadingDialog = false;
            });
    },
    postFileRequest({ commit }, { self }) {
        var requestParams = self.requestParams;
        axios
            .post(
                self.$store.state.settings.server + requestParams.controller, //Controller URL
                requestParams.data, //POST Data
                {
                    //Headers
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + self.$store.state.userInfo.accessToken,
                    },
                }
            )
            .then((response) => {
                var data = response.data;
                commit(requestParams.commitFunction, data);
                self.requestParams.callBack(200);
            })
            .catch((error) => {
                if (error && error.response && error.response.status) {
                    if (error.response.status == 401) {
                        store.dispatch("loginredirect");
                        self.$router.push("login");
                        return;
                    }
                }
                self.requestParams.callBack(-200);
            });
    },
    getFileRequest({ commit }, { self }) {
        var requestParams = self.requestParams;
        axios
            .get(self.$store.state.settings.server + requestParams.controller, {
                //Headers
                headers: {
                    Authorization: "Bearer " + self.$store.state.userInfo.accessToken,
                },
            })
            .then((response) => {
                let pdfWindow = window.open("");
                pdfWindow.document.write(
                    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                    encodeURI(response.data) +
                    "'></iframe>"
                );
            })
            .catch((error) => {
                if (error && error.response && error.response.status) {
                    if (error.response.status == 401) {
                        store.dispatch("loginredirect");
                        self.$router.push("login");
                        return;
                    }
                }
                self.requestParams.callBack(-200);
            });
    },
    getFileRequestWithData({ commit }, { self }) {
        var requestParams = self.requestParams;
        axios
            .post(
                self.$store.state.settings.server + requestParams.controller,
                requestParams.data, //Controller URL
                {
                    //Headers
                    headers: {
                        Authorization: "Bearer " + self.$store.state.userInfo.accessToken,
                    },
                }
            )
            .then((response) => {
                self.$store.state.loadingDialog = false;
                let pdfWindow = window.open("");
                pdfWindow.document.write(
                    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                    encodeURI(response.data) +
                    "'></iframe>"
                );
            })
            .catch((error) => {
                if (error && error.response && error.response.status) {
                    if (error.response.status == 401) {
                        store.dispatch("loginredirect");
                        self.$router.push("login");
                        return;
                    }
                }
                self.requestParams.callBack(-200);
            });
    },
    getExcelFile({ commit }, { self }) {
        var requestParams = self.requestParams;
        axios({
            url:
                self.$store.state.settings.server + requestParams.controller,
            method: "GET",
            responseType: "blob",
        }).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `1.xlsx`);
            document.body.appendChild(link);
            link.click();
        });
    }
};